<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Property Details</h5>
  <div class="d-flex align-items-center gap-2  ms-auto">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openAuditForForm()">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
  </div>
</div>

<div class="modal-body">

<div *ngIf="!dataLoaded" class="d-flex justify-content-center py-5">
    <div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <form [formGroup]="propertyDetails" autocomplete="off" *ngIf="dataLoaded">

    <!-- Purchase Address -->
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Purchase Postcode</label>
        <div class="input-group">
          <input class="form-control" #purchasePostcode maxlength="10"
            formControlName="purchasePostcode" (change)="updateField()">
          <app-address-lookup-button [for]="addressLookup1"></app-address-lookup-button>
        </div>
      </div>
    </div>

    <app-address-lookup #addressLookup1 lookupType="postcode" [searchField]="purchasePostcode"
      [add1]="propertyDetails.controls['purchaseAddressLine1']"
      [add2]="propertyDetails.controls['purchaseAddressLine2']"
      [add3]="propertyDetails.controls['purchaseAddressLine3']"
      [add4]="propertyDetails.controls['purchaseAddressLine4']"
      [add5]="propertyDetails.controls['purchaseAddressLine5']"
      [addPc]="propertyDetails.controls['purchasePostcode']"
      (change)="updateField()">
    </app-address-lookup>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 1</label>
        <input class="form-control" maxlength="100" formControlName="purchaseAddressLine1" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 2</label>
        <input class="form-control" maxlength="100" formControlName="purchaseAddressLine2" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 3</label>
        <input class="form-control" maxlength="100" formControlName="purchaseAddressLine3" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 4</label>
        <input class="form-control" maxlength="100" formControlName="purchaseAddressLine4" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 5</label>
        <input class="form-control" maxlength="100" formControlName="purchaseAddressLine5" (change)="updateField()">
      </div>
    </div>

    <!-- Property details -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Is property Unregistered?</label>
        <app-yes-no-form-toggle class="d-block" formControlName="propertyIsUnregistered" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Title Number</label>
        <input class="form-control" formControlName="titleNumber" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Property Type</label>
        <select class="form-select" formControlName="propertyType" (change)="updateField()">
          <option [ngValue]="null"></option>
          <option [ngValue]="1">Leasehold</option>
          <option [ngValue]="2">Freehold</option>
        </select>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Title Guarantee Type</label>
        <select class="form-select" formControlName="titleGuaranteeType" (change)="updateField()">
          <option [ngValue]="null"></option>
          <option [ngValue]="1">Full Title Guarantee</option>
          <option [ngValue]="2">Limited Title Guarantee</option>
        </select>
      </div>
    </div>

    <!-- Leasehold section -->
    <div [hidden]="propertyDetails.controls['propertyType'].value != 1">
      <hr class="my-3">
      <h6 class="fw-bold mb-3">Landlord Details</h6>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Full Name</label>
          <input class="form-control" maxlength="100" formControlName="landlordName" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Postcode</label>
          <div class="input-group">
            <input class="form-control" #landlordPostcode maxlength="10"
              formControlName="landlordPostcode" (change)="updateField()">
            <app-address-lookup-button [for]="addressLookup4"></app-address-lookup-button>
          </div>
        </div>
      </div>

      <app-address-lookup #addressLookup4 lookupType="postcode" [searchField]="landlordPostcode"
        [add1]="propertyDetails.controls['landlordAddressLine1']"
        [add2]="propertyDetails.controls['landlordAddressLine2']"
        [add3]="propertyDetails.controls['landlordAddressLine3']"
        [add4]="propertyDetails.controls['landlordAddressLine4']"
        [add5]="propertyDetails.controls['landlordAddressLine5']"
        [addPc]="propertyDetails.controls['landlordPostcode']"
        (change)="updateField()">
      </app-address-lookup>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Address Line 1</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine1" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Address Line 2</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine2" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Address Line 3</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine3" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Address Line 4</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine4" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Landlord Address Line 5</label>
          <input class="form-control" maxlength="100" formControlName="landlordAddressLine5" (change)="updateField()">
        </div>
      </div>

      <hr class="my-3">
      <h6 class="fw-bold mb-3">Management Company</h6>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Management Company Name</label>
          <input class="form-control" formControlName="managementCompanyName" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Management Company Postcode</label>
          <div class="input-group">
            <input class="form-control" #managementCompanyPostcode maxlength="10"
              formControlName="managementCompanyPostcode" (change)="updateField()">
            <app-address-lookup-button [for]="addressLookup5"></app-address-lookup-button>
          </div>
        </div>
      </div>

      <app-address-lookup #addressLookup5 lookupType="postcode" [searchField]="managementCompanyPostcode"
        [add1]="propertyDetails.controls['managementCompanyAddressLine1']"
        [add2]="propertyDetails.controls['managementCompanyAddressLine2']"
        [add3]="propertyDetails.controls['managementCompanyAddressLine3']"
        [add4]="propertyDetails.controls['managementCompanyAddressLine4']"
        [add5]="propertyDetails.controls['managementCompanyAddressLine5']"
        [addPc]="propertyDetails.controls['managementCompanyPostcode']"
        (change)="updateField()">
      </app-address-lookup>

      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 1</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine1" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 2</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine2" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 3</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine3" (change)="updateField()">
        </div>
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 4</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine4" (change)="updateField()">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Address Line 5</label>
          <input class="form-control" maxlength="100" formControlName="managementCompanyAddressLine5" (change)="updateField()">
        </div>
      </div>
    </div>

    <!-- Solar Panels -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Solar Panels</label>
        <app-yes-no-form-toggle class="d-block" formControlName="solarPanelsPresent" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <div [hidden]="propertyDetails.controls['solarPanelsPresent'].value != 1">
      <div class="row mb-3">
        <div class="col-sm-6">
          <label class="form-label fw-semibold">Are the solar panels owned outright?</label>
          <app-yes-no-form-toggle class="d-block" formControlName="solarPanelsOwnedOutright" (change)="updateField()"></app-yes-no-form-toggle>
        </div>
      </div>

      <div [hidden]="propertyDetails.controls['solarPanelsOwnedOutright'].value != 0">
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Solar Panels Company Name</label>
            <input class="form-control" formControlName="solarPanelsCompany" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Solar Panel Owner Postcode</label>
            <div class="input-group">
              <input class="form-control" #solarPanelsOwnerPostcode maxlength="10"
                formControlName="solarPanelsOwnerPostcode" (change)="updateField()">
              <app-address-lookup-button [for]="addressLookup2"></app-address-lookup-button>
            </div>
          </div>
        </div>

        <app-address-lookup #addressLookup2 lookupType="postcode" [searchField]="solarPanelsOwnerPostcode"
          [add1]="propertyDetails.controls['solarPanelsOwnerAddressLine1']"
          [add2]="propertyDetails.controls['solarPanelsOwnerAddressLine2']"
          [add3]="propertyDetails.controls['solarPanelsOwnerAddressLine3']"
          [add4]="propertyDetails.controls['solarPanelsOwnerAddressLine4']"
          [add5]="propertyDetails.controls['solarPanelsOwnerAddressLine5']"
          [addPc]="propertyDetails.controls['solarPanelsOwnerPostcode']"
          (change)="updateField()">
        </app-address-lookup>

        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 1</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine1" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 2</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine2" (change)="updateField()">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 3</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine3" (change)="updateField()">
          </div>
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 4</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine4" (change)="updateField()">
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-sm-6">
            <label class="form-label fw-semibold">Address Line 5</label>
            <input class="form-control" maxlength="100" formControlName="solarPanelsOwnerAddressLine5" (change)="updateField()">
          </div>
        </div>
      </div>
    </div>

    <!-- Septic Tank / Prices -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Septic Tank</label>
        <app-yes-no-form-toggle class="d-block" formControlName="hasSepticTank" (change)="updateField()"></app-yes-no-form-toggle>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Agreed Purchase Price</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="agreedPurchasePrice" (change)="updateField()">
        </div>
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Chattels</label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="chattels" (change)="updateField()">
        </div>
      </div>
    </div>

    <app-allowance [caseId]="caseId"></app-allowance>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">
          Stamp Duty/Land Tax
          <a href="https://www.gov.uk/stamp-duty-land-tax/residential-property-rates" target="_blank" class="ms-2">
            <fa-icon [icon]="faExternalLink"></fa-icon>
          </a>
        </label>
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input class="form-control" formControlName="stampDuty" (change)="updateField()">
        </div>
      </div>
    </div>

    <!-- Seller Solicitor -->
    <hr class="my-3">
    <h6 class="fw-bold mb-3">Seller Solicitor</h6>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Seller Solicitor Name</label>
        <input class="form-control" formControlName="sellerSolicitorName" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Seller Solicitor Email Address</label>
        <input class="form-control" formControlName="sellerSolicitorEmailAddress" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Seller Solicitor Contact Number</label>
        <input class="form-control" formControlName="sellerSolicitorContactNumber" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Seller Solicitor Reference</label>
        <input class="form-control" formControlName="sellerSolicitorReference" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Seller Solicitor Postcode</label>
        <div class="input-group">
          <input class="form-control" #sellerSolicitorPostcode maxlength="10"
            formControlName="sellerSolicitorPostcode" (change)="updateField()">
          <app-address-lookup-button [for]="addressLookup6"></app-address-lookup-button>
        </div>
      </div>
    </div>

    <app-address-lookup #addressLookup6 lookupType="postcode" [searchField]="sellerSolicitorPostcode"
      [add1]="propertyDetails.controls['sellerSolicitorAddressLine1']"
      [add2]="propertyDetails.controls['sellerSolicitorAddressLine2']"
      [add3]="propertyDetails.controls['sellerSolicitorAddressLine3']"
      [add4]="propertyDetails.controls['sellerSolicitorAddressLine4']"
      [add5]="propertyDetails.controls['sellerSolicitorAddressLine5']"
      [addPc]="propertyDetails.controls['sellerSolicitorPostcode']"
      (change)="updateField()">
    </app-address-lookup>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 1</label>
        <input class="form-control" maxlength="100" formControlName="sellerSolicitorAddressLine1" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 2</label>
        <input class="form-control" maxlength="100" formControlName="sellerSolicitorAddressLine2" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 3</label>
        <input class="form-control" maxlength="100" formControlName="sellerSolicitorAddressLine3" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 4</label>
        <input class="form-control" maxlength="100" formControlName="sellerSolicitorAddressLine4" (change)="updateField()">
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Address Line 5</label>
        <input class="form-control" maxlength="100" formControlName="sellerSolicitorAddressLine5" (change)="updateField()">
      </div>
    </div>

    <!-- Seller Names -->
    <hr class="my-3">
    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Seller 1 Name</label>
        <input class="form-control" formControlName="seller1Name" (change)="updateField()">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Seller 2 Name</label>
        <input class="form-control" formControlName="seller2Name" (change)="updateField()">
      </div>
    </div>

  </form>
</div>